import { checkIsCompleteFit } from '@helpers/customer/fit'
import CustomerSavedFit from './CustomerSavedFit'
import useIsReactClient from '@helpers/hooks/useIsReactClient'
import NoSavedFit from './NoSavedFit'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'
import { useFit } from '@helpers/hooks/useFit'

function AccountMyFit() {
  const { isLoggedIn } = useLogin()
  const isReactClient = useIsReactClient()
  const { savedFit } = useFit()
  const hasSavedFit = savedFit && checkIsCompleteFit(savedFit)

  return (
    <>
      {hasSavedFit && isLoggedIn && isReactClient ? (
        <CustomerSavedFit savedFit={savedFit} />
      ) : (
        <NoSavedFit />
      )}
    </>
  )
}
export default AccountMyFit
